import Icon from "../../components/elements/Icons/Icon";
import OpacityContainer from "../../components/elements/OpacityContainer/OpacityContainer";
import MiddleBlock from "../../components/MiddleBlock/MiddleBlock";
import SectionHeader from "../../components/SectionHeader/SectionHeader";
import "./Support.css"

export default function Support() {
    return (
        <>
            <SectionHeader>Dołącz do nas</SectionHeader>
            <MiddleBlock>
                <div className="support-container">
                    <OpacityContainer
                        background={"rgba(236, 225, 207, .15"}
                        borderColor={"#DCD0BC"}
                        shadowColor={"#DAC7A9"}
                        title="Wolontariat"
                        description={"Każdy wolontariusz wnosi coś wyjątkowego do naszej fundacji. Jako wolontariusz, będziesz mieć możliwość aktywnego uczestnictwa w naszych projektach, a szczególnie organizacji wydarzeń. Umiejętności, które pomogą w nie jednym wyzwaniu życiowym. Razem możemy więcej i lepiej."}
                        number={"support_first"}
                    >
                        <div className="check-support-block">
                            <div className="support-block-li">
                                <Icon name={"check"} />
                                <span>Organizacja wydarzeń</span>
                            </div>
                            <div className="support-block-li">
                                <Icon name={"check"} />
                                <span>Wsparcie administracyjne</span>
                            </div>
                            <div className="support-block-li">
                                <Icon name={"check"} />
                                <span>Promocja i marketing</span>
                            </div>
                        </div>
                    </OpacityContainer>
                    <OpacityContainer
                        background={"rgba(236, 225, 207, .15"}
                        borderColor={"#DCD0BC"}
                        shadowColor={"#DAC7A9"}
                        title="Sponsoring"
                        description={"Współpraca z naszą fundacją to szansa na wsparcie młodych artystów i jednoczesną promocję Twojej marki. Dzięki sponsoringowi organizujemy większe wydarzenia, kupujemy sprzęt i materiały, a także zwiększamy widoczność twórców. Skontaktuj się z nami, aby omówić szczegóły współpracy i dostosować pakiet sponsoringowy."}
                        number={"support_second"}
                    >
                        <div className="check-support-block">
                            <div className="support-block-li">
                                <Icon name={"check"} />
                                <span>Widoczność</span>
                            </div>
                            <div className="support-block-li">
                                <Icon name={"check"} />
                                <span>Współpraca</span>
                            </div>
                            <div className="support-block-li">
                                <Icon name={"check"} />
                                <span>Wzmocnienie wizerunku firmy</span>
                            </div>
                        </div>
                    </OpacityContainer>

                    <OpacityContainer
                        background={"rgba(236, 225, 207, .15"}
                        borderColor={"#DCD0BC"}
                        shadowColor={"#DAC7A9"}
                        title="Darowizna"
                        description={"Twoja darowizna finansowa dla Fundacji MANA to kluczowy element w naszej misji wspierania młodych artystów. Każda wpłata, przyczynia się do rozwoju talentów i umożliwia im realizację ich marzeń."}
                        number={"support_first"}
                    >
                        <div className="check-support-block">
                            <div className="support-block-li">
                                <Icon name={"check"} />
                                <span>Jednorazowe darowizny</span>
                            </div>
                            <div className="support-block-li">
                                <Icon name={"check"} />
                                <span>Cykliczne darowizny</span>
                            </div>
                        </div>
                        <div className="opacity-block-bottom">
                            <p className="opacity-block-card-number">
                                Konto Fundacji: <span>14 1090 2398 0000 0001 5587 9009</span>
                            </p>
                            <p className="opacity-block-small-text">
                                Darowizny przekazane w formie przelewu na konto naszej fundacji można odliczyć od podstawy obliczenia podatku dochodowego zgodnie z art. 26 ust. 1 pkt 9 lit. a ustawy o PIT. Można odliczyć kwotę faktycznie przekazanej darowizny, nie więcej jednak niż 6 proc. swojego dochodu (art. 26 ust. 5 ustawy o PIT)
                            </p>
                        </div>
                    </OpacityContainer>
                </div>
            </MiddleBlock>
        </>
    )
}